import React from "react";
import ci from "../assets/images/kbg_ci.png";

const NotFoundPage = () => {
  return (
    <div className="text-center mt-10 p-10">
      <div className="flex justify-center">
        <img
          src={ci}
          alt="CI"
          width="300"
          height="300"
          style={{ pointerEvents: "none" }}
        />
      </div>
      <h1 className="text-9xl font-bold" style={{ color: "#E9282B" }}>
        404
      </h1>
      <p className="mt-7 text-xl text-gray-600">
        죄송합니다. 현재 찾을 수 없는 페이지를 요청 하셨습니다.
      </p>
      <p className="mt-5 text-gray-500">존재하지 않는 주소를 입력하셨거나,</p>
      <p className="mt-1 text-gray-500">
        주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수 없습니다.
      </p>
      {/* <a
        href="/"
        className="mt-10 inline-block px-6 py-3 text-white bg-slate-500 rounded hover:bg-slate-600"
      >
        메인으로
      </a> */}
    </div>
  );
};

export default NotFoundPage;
